/**
 * Parse the elements array into object keys for faster
 * lookup
 *
 * @param {Array} elements - the elements
 * @returns {object} the parsed elements
 */
export default function elementsArrayToKeys (elements) {
  return elements.reduce((res, item) => {
    res[item.id] = {
      ...item
    }

    return res
  }, {})
}
